import AccessibilityHelper from './AccessibilityHelper';
import ErrorLogger from './ErrorLogger';
import InactivityHelper from './InactivityHelper';
import KeyboardHelper from './KeyboardHelper';
import { activityTyping, application, keyboard, mapState, mapMutations, mapActions, mapGetters } from '../store/helpers';
import { osName } from 'react-device-detect';
import mixins from 'vue-typed-mixins';
export default mixins(AccessibilityHelper, ErrorLogger, InactivityHelper, KeyboardHelper).extend({
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters(activityTyping, [
        'isTouchHold',
        'isEndOfCurrentText',
        'isEndOfCurrentWord',
        'isEndOfCurrentSentence',
        'isEndOfRound',
        'expectedKey'
    ])), mapState(activityTyping, {
        attemptedKey: 'attemptedKey',
        typingProgress: 'progress'
    })), mapState(keyboard, {
        keyboardEnabled: state => state.enabled
    })),
    data() {
        return {
            isDisplayingKeyboardingErrorModal: false
        };
    },
    methods: Object.assign(Object.assign(Object.assign(Object.assign({}, mapMutations(activityTyping, ['incrementTypingIndex'])), mapMutations(application, ['setModal'])), mapActions(activityTyping, ['setupNewRound', 'setCurrentStep'])), { captureKeyboardAttemptSegment(attempt, isEndOfSentence, options) {
            this.setKeyboardingSegmentAlert(attempt, isEndOfSentence, options);
        },
        isChromeOSDeadKey(key) {
            if (osName !== 'Chromium OS')
                return false;
            if (key === 'Dead' || key === 'Process') {
                return true;
            }
            return false;
        },
        handleChromeOSDeadKey() {
            this.isDisplayingKeyboardingErrorModal = true;
            this.setModal({
                type: 'keyboardError',
                data: null,
                onClose: () => {
                    this.isDisplayingKeyboardingErrorModal = false;
                }
            });
        } }),
    // handleWrongKey is base method in ActivityManager. Activities implement handleCorrectKey.
    watch: {
        attemptedKey(attempt) {
            if (this.isChromeOSDeadKey(attempt.character) && !this.isDisplayingKeyboardingErrorModal) {
                this.handleChromeOSDeadKey();
                return;
            }
            if (this.isDisplayingKeyboardingErrorModal) {
                return;
            }
            if (this.isActiveAssessment) {
                this.resetTimer();
            }
            if (attempt.character && !attempt.character.includes('shift')) {
                if (attempt.isCorrect) {
                    //@ts-ignore implemented by consumer
                    this.handleCorrectKey(attempt);
                    this.logCorrectCharacter(attempt.character);
                }
                else {
                    //@ts-ignore implemented by consumer
                    this.handleWrongKey(attempt);
                }
            }
        }
    }
});
